export const HostingFilters = () => {
  return [{
    label: 'Cloud',
    id: 'cloud',
    value: 'cloud'
  }, {
    label: 'Data Center',
    id: 'dataCenter',
    value: 'dataCenter'
  }, {
    label: 'Server',
    id: 'server',
    value: 'server'
  }];
};